/**
 * Constants for Durin AI client
 */

// Default timeout for requests (40 seconds)
export const DEFAULT_TIMEOUT = 40000;

// Known model providers
export const MODEL_PROVIDERS = {
  ANTHROPIC: 'Anthropic'
} as const;

// Valid tone options for rewrite intent
export const REWRITE_TONES = [
  'friendly', 
  'professional',
  'concise'
] as const;

// Valid length options for summarize intent
export const SUMMARY_LENGTHS = [
  'brief',
  'standard', 
  'detailed'
] as const;

// Valid format options for summarize intent
export const SUMMARY_FORMATS = [
  'paragraph',
  'bullets',
  'numbered'
] as const;

// Stream chunk types
export const STREAM_CHUNK_TYPES = {
  START: 'start',
  CONTENT: 'content',
  END: 'end'
} as const;

// Finish reasons
export const FINISH_REASONS = {
  STOP: 'stop',
  LENGTH: 'length',
  ERROR: 'error'
} as const;